import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '@sb/library/button';
import { FormFieldModule } from '@sb/library/form-field';
import { LayoutModule } from '@sb/library/layout';
import { SubmissionBarModule } from '@sb/library/submission-bar';
import { UnsavedFormChangesDialogComponent } from './dialogs/unsaved-form-changes-dialog.component';
import { CalendarEventLocationIconPipe } from './pipes/calendar-event-location-icon.pipe';
import { PostIconPipe } from './pipes/post-icon.pipe';
import { SocialMediaLinkIconPipe } from './pipes/social-media-link-icon.pipe';

@NgModule({
    declarations: [
        PostIconPipe,
        CalendarEventLocationIconPipe,
        UnsavedFormChangesDialogComponent,
        SocialMediaLinkIconPipe
    ],
    imports: [
        CommonModule,
        LayoutModule,
        ButtonModule,
        FormFieldModule,
        SubmissionBarModule
    ],
    exports: [
        PostIconPipe,
        CalendarEventLocationIconPipe,
        SocialMediaLinkIconPipe
    ]
})
export class ManagersModule { }
